import { render, staticRenderFns } from "./profile-image.vue?vue&type=template&id=5af9e4e5"
import script from "./profile-image.vue?vue&type=script&lang=js"
export * from "./profile-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports